export enum WalletType {
  SPOT = "SPOT",
  FUTURES = "FUTURES",
  MARGIN = "MARGIN",
  OPTIONS = "OPTIONS",
}

export enum WalletStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  SUSPENDED = "SUSPENDED",
}

export interface Wallet {
  id: string;
  name: string;
  type: WalletType;
  status: WalletStatus;
  description?: string;
  userId?: string;
  balance: number;
  currency: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateWalletInput {
  name: string;
  type: WalletType;
  status?: WalletStatus;
  description?: string;
  userId?: string;
  balance: number;
  currency?: string;
}

export interface UpdateWalletInput {
  name?: string;
  type?: WalletType;
  status?: WalletStatus;
  description?: string;
  userId?: string;
  balance?: number;
  currency?: string;
}

export interface WalletFilterInput {
  name?: string;
  type?: WalletType;
  status?: WalletStatus;
  userId?: string;
}

export interface WalletStats {
  wallet: Wallet;
  stats: {
    totalTrades: number;
    openPositions: number;
    totalPositions: number;
    currentBalance: number;
  };
}
